const defaultState = {
  report: {},
  error: null,
  fetching: false,
  fetched: false
};

const getACAReportJsonDataReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'ACA_BILLING_REPORT_DATA_CLEAR': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: null
      };
    }
    case 'ACA_BILLING_REPORT_DATA_PENDING': {
      return {
        ...state, error: null, fetching: true, report: {}
      };
    }
    case 'ACA_BILLING_REPORT_DATA_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: action.payload.data
      };
    }
    case 'ACA_BILLING_REPORT_DATA_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        report: {},
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default getACAReportJsonDataReducer;


// WEBPACK FOOTER //
// ./src/reducers/getACAReportJsonData.js